import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Attestation"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { gr.tech.GRAttestation.pages.HomePage() }
        ctx.router.register("/admin/") { gr.tech.GRAttestation.pages.admin.AdminDashboardPage() }
        ctx.router.register("/admin/activity/") {
                gr.tech.GRAttestation.pages.admin.activity.AdminActivityPage() }
        ctx.router.register("/admin/login/") {
                gr.tech.GRAttestation.pages.admin.login.UserLoginPage() }
        ctx.router.register("/admin/models/") {
                gr.tech.GRAttestation.pages.admin.models.AdminSKUsPage() }
        ctx.router.register("/admin/stores/") {
                gr.tech.GRAttestation.pages.admin.stores.AdminStoresPage() }
        ctx.router.register("/admin/stores/{id}") {
                gr.tech.GRAttestation.pages.admin.stores.AdminStoreDetailsPage() }
        ctx.router.register("/admin/stores/{id}/receipts") {
                gr.tech.GRAttestation.pages.admin.stores.AdminStoreReceiptPage() }
        ctx.router.register("/admin/users/") {
                gr.tech.GRAttestation.pages.admin.users.AdminUsersPage() }
        ctx.router.register("/finish-registration") {
                gr.tech.GRAttestation.pages.FinishRegistrationPage() }
        ctx.router.register("/forgot-password") { gr.tech.GRAttestation.pages.ForgotPasswordPage() }
        ctx.router.register("/login") { gr.tech.GRAttestation.pages.LoginPage() }
        ctx.router.register("/privacy-policy") { gr.tech.GRAttestation.pages.PrivacyPage() }
        ctx.router.register("/reset-password") { gr.tech.GRAttestation.pages.ResetPasswordPage() }
        ctx.router.register("/terms-conditions") { gr.tech.GRAttestation.pages.TermsPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("default-carousel",
                gr.tech.GRAttestation.components.DefaultCarouselStyle)
        ctx.theme.registerStyle("store-pagination",
                gr.tech.GRAttestation.components.StorePaginationStyle)
        ctx.theme.registerStyle("admin-page-content",
                gr.tech.GRAttestation.components.layouts.AdminPageContentStyle)
        ctx.theme.registerStyle("page-content",
                gr.tech.GRAttestation.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("modal-overlay",
                gr.tech.GRAttestation.components.modals.ModalOverlayStyle)
        ctx.theme.registerStyle("modal-content-animation",
                gr.tech.GRAttestation.components.modals.ModalContentAnimation)
        ctx.theme.registerStyle("signature-canvas",
                gr.tech.GRAttestation.infrastructure.signature.signatureCanvasStyle)
        ctx.theme.registerStyle("basic-button",
                gr.tech.GRAttestation.infrastructure.signature.basicButtonStyle)
        ctx.theme.registerStyle("form-container", gr.tech.GRAttestation.pages.formContainer)
        ctx.theme.registerStyle("admin-detail-list",
                gr.tech.GRAttestation.pages.admin.stores.adminDetailListStyle)
        ctx.theme.registerStyle("admin-input-row",
                gr.tech.GRAttestation.pages.admin.stores.adminInputRowStyle)
        ctx.theme.registerStyle("admin-input-row-label",
                gr.tech.GRAttestation.pages.admin.stores.adminInputRowLabelStyle)
        ctx.theme.registerStyle("admin-input-row-non-edit",
                gr.tech.GRAttestation.pages.admin.stores.adminInputRowNonEditStyle)
        ctx.theme.registerStyle("admin-input-row-edit",
                gr.tech.GRAttestation.pages.admin.stores.adminInputRowEditStyle)
        ctx.theme.registerStyle("admin-input-error",
                gr.tech.GRAttestation.pages.admin.stores.adminInputErrorStyle)
        ctx.theme.registerStyle("footer-section", gr.tech.GRAttestation.sections.FooterSectionStyle)
        ctx.theme.registerStyle("footer-link-section",
                gr.tech.GRAttestation.sections.FooterLinkSection)
        ctx.theme.registerStyle("footer-link", gr.tech.GRAttestation.sections.FooterLinkStyle)
        ctx.theme.registerStyle("footer-column", gr.tech.GRAttestation.sections.FooterColumnStyle)
        ctx.theme.registerStyle("footer-title", gr.tech.GRAttestation.sections.FooterTitleStyle)
        ctx.theme.registerStyle("footer-text", gr.tech.GRAttestation.sections.FooterTextStyle)
        ctx.theme.registerStyle("message-box-container",
                gr.tech.GRAttestation.sections.MessageBoxContainer)
        ctx.theme.registerStyle("status-text", gr.tech.GRAttestation.sections.StatusTextStyle)
        ctx.theme.registerStyle("side-nav-container",
                gr.tech.GRAttestation.sections.admin.SideNavContainerStyle)
        ctx.theme.registerStyle("fixed-container",
                gr.tech.GRAttestation.sections.admin.FixedContainer)
        ctx.theme.registerStyle("navigation-item",
                gr.tech.GRAttestation.sections.admin.NavigationItemStyle)
        ctx.theme.registerStyle("current-navigation-item",
                gr.tech.GRAttestation.sections.admin.CurrentNavigationItemStyle)
        ctx.theme.registerStyle("side-nav-text",
                gr.tech.GRAttestation.sections.admin.SideNavTextStyle)
        ctx.theme.registerStyle("side-nav-icon",
                gr.tech.GRAttestation.sections.admin.SideNavIconStyle)
        ctx.theme.registerStyle("attestation-form",
                gr.tech.GRAttestation.sections.forms.attestationFormStyle)
        ctx.theme.registerStyle("form-title", gr.tech.GRAttestation.sections.forms.formTitleStyle)
        ctx.theme.registerStyle("input-row-container",
                gr.tech.GRAttestation.sections.forms.InputRowContainer)
        ctx.theme.registerStyle("product-row-container",
                gr.tech.GRAttestation.sections.forms.ProductRowContainer)
        ctx.theme.registerStyle("product-sum-data",
                gr.tech.GRAttestation.sections.forms.ProductSumDataStyle)
        ctx.theme.registerStyle("table-row-preview",
                gr.tech.GRAttestation.sections.forms.TableRowPreview)
        ctx.theme.registerStyle("table-column-header",
                gr.tech.GRAttestation.sections.forms.TableColumnHeader)
        ctx.theme.registerStyle("table-column-preview",
                gr.tech.GRAttestation.sections.forms.TableColumnPreview)
        ctx.theme.registerStyle("download-button",
                gr.tech.GRAttestation.sections.tables.DownloadButtonStyle)
        ctx.theme.registerStyle("responsive-dual-column",
                gr.tech.GRAttestation.styles.ResponsiveDualColumn)
        ctx.theme.registerStyle("loading-skeleton", gr.tech.GRAttestation.styles.LoadingSkeleton)
        ctx.theme.registerStyle("auth-logo", gr.tech.GRAttestation.styles.AuthLogoStyle)
        ctx.theme.registerStyle("auth-title", gr.tech.GRAttestation.styles.AuthTitleStyle)
        ctx.theme.registerStyle("auth-subtitle", gr.tech.GRAttestation.styles.AuthSubtitleStyle)
        ctx.theme.registerStyle("auth-error", gr.tech.GRAttestation.styles.AuthErrorStyle)
        ctx.theme.registerStyle("auth-box", gr.tech.GRAttestation.styles.AuthBoxStyle)
        ctx.theme.registerStyle("auth-card", gr.tech.GRAttestation.styles.AuthCardStyle)
        ctx.theme.registerStyle("auth-card-header",
                gr.tech.GRAttestation.styles.AuthCardHeaderStyle)
        ctx.theme.registerStyle("auth-label", gr.tech.GRAttestation.styles.AuthLabelStyle)
        ctx.theme.registerStyle("auth-input", gr.tech.GRAttestation.styles.AuthInputStyle)
        ctx.theme.registerStyle("auth-button", gr.tech.GRAttestation.styles.AuthButtonStyle)
        ctx.theme.registerStyle("overlay-box", gr.tech.GRAttestation.styles.OverlayBoxStyle)
        ctx.theme.registerStyle("gen-horizontal-divider",
                gr.tech.GRAttestation.styles.GenHorizontalDivider)
        ctx.theme.registerStyle("gen-header-logo", gr.tech.GRAttestation.styles.GenHeaderLogoStyle)
        ctx.theme.registerStyle("gen-header", gr.tech.GRAttestation.styles.GenHeaderStyle)
        ctx.theme.registerStyle("gen-sales-data-count",
                gr.tech.GRAttestation.styles.GenSalesDataCount)
        ctx.theme.registerStyle("gen-table-column-header",
                gr.tech.GRAttestation.styles.GenTableColumnHeader)
        ctx.theme.registerStyle("gen-table-column", gr.tech.GRAttestation.styles.GenTableColumn)
        ctx.theme.registerStyle("receipt-page", gr.tech.GRAttestation.styles.receiptPageStyle)
        ctx.theme.registerStyle("receipts-container",
                gr.tech.GRAttestation.styles.ReceiptsContainerStyle)
        ctx.theme.registerStyle("receipt-text", gr.tech.GRAttestation.styles.ReceiptTextStyle)
        ctx.theme.registerStyle("receipt-table-column-header",
                gr.tech.GRAttestation.styles.ReceiptTableColumnHeader)
        ctx.theme.registerStyle("receipt-table-column",
                gr.tech.GRAttestation.styles.ReceiptTableColumn)
        ctx.theme.registerStyle("input-container", gr.tech.GRAttestation.styles.InputContainerStyle)
        ctx.theme.registerStyle("general-form-error-text",
                gr.tech.GRAttestation.styles.GeneralFormErrorTextStyle)
        ctx.theme.registerStyle("general-input-label",
                gr.tech.GRAttestation.styles.GeneralInputLabelStyle)
        ctx.theme.registerStyle("general-input", gr.tech.GRAttestation.styles.GeneralInputStyle)
        ctx.theme.registerStyle("general-input-error",
                gr.tech.GRAttestation.styles.GeneralInputErrorStyle)
        ctx.theme.registerStyle("general-paragraph",
                gr.tech.GRAttestation.styles.GeneralParagraphStyle)
        ctx.theme.registerStyle("pdf-status-text", gr.tech.GRAttestation.styles.PDFStatusTextStyle)
        ctx.theme.registerStyle("pdf-column-overlay", gr.tech.GRAttestation.styles.PDFColumnOverlay)
        ctx.theme.registerStyle("pdf-back-button", gr.tech.GRAttestation.styles.PDFBackButtonStyle)
        ctx.theme.registerStyle("smaller-item-paragraph",
                gr.tech.GRAttestation.styles.SmallerItemParagraphStyle)
        ctx.theme.registerStyle("bold-underline", gr.tech.GRAttestation.styles.BoldUnderline)
        ctx.theme.registerStyle("bold-italic", gr.tech.GRAttestation.styles.BoldItalic)
        ctx.theme.registerStyle("inserted-field", gr.tech.GRAttestation.styles.insertedFieldStyle)
        ctx.theme.registerStyle("background", gr.tech.GRAttestation.styles.backgroundStyle)
        ctx.theme.registerStyle("page", gr.tech.GRAttestation.styles.pageStyle)
        ctx.theme.registerStyle("admin-summary-box",
                gr.tech.GRAttestation.styles.admin.AdminSummaryBoxStyle)
        ctx.theme.registerStyle("admin-summary-title",
                gr.tech.GRAttestation.styles.admin.AdminSummaryTitleStyle)
        ctx.theme.registerStyle("admin-table-sticky-column",
                gr.tech.GRAttestation.styles.admin.AdminTableStickyColumn)
        ctx.theme.registerStyle("generic-button",
                gr.tech.GRAttestation.styles.grstyles.GenericButtonStyle)
        ctx.theme.registerStyle("generic-link-button",
                gr.tech.GRAttestation.styles.grstyles.GenericLinkButtonStyle)
        ctx.theme.registerStyle("dark-green-hover-button",
                gr.tech.GRAttestation.styles.grstyles.DarkGreenHoverButtonStyle)
        ctx.theme.registerStyle("dark-green-outline-hover-button",
                gr.tech.GRAttestation.styles.grstyles.DarkGreenOutlineHoverButtonStyle)
        ctx.theme.registerStyle("login-page-button",
                gr.tech.GRAttestation.styles.grstyles.LoginPageButtonStyle)
        ctx.theme.registerStyle("horizontal-divider-dark",
                gr.tech.GRAttestation.styles.grstyles.HorizontalDividerDark)
        ctx.theme.registerStyle("dropdown-link",
                gr.tech.GRAttestation.styles.grstyles.DropdownLinkStyle)
        ctx.theme.registerStyle("default-placeholder",
                gr.tech.GRAttestation.styles.grstyles.defaultPlaceholderStyle)
        ctx.theme.registerStyle("default-table",
                gr.tech.GRAttestation.styles.grstyles.DefaultTableStyle)
        ctx.theme.registerStyle("default-table-header",
                gr.tech.GRAttestation.styles.grstyles.DefaultTableHeaderStyle)
        ctx.theme.registerStyle("terms-list", gr.tech.GRAttestation.styles.grstyles.termsListStyle)
        ctx.theme.registerStyle("terms-paragraph",
                gr.tech.GRAttestation.styles.grstyles.termsParagraphStyle)
        ctx.theme.registerStyle("button-color-fade",
                gr.tech.GRAttestation.styles.grstyles.buttonColorFadeStyle)
        ctx.theme.registerStyle("portal-input-label",
                gr.tech.GRAttestation.styles.store.PortalInputLabelStyle)
        ctx.theme.registerStyle("portal-input", gr.tech.GRAttestation.styles.store.PortalInputStyle)
        ctx.theme.registerStyle("portal-select",
                gr.tech.GRAttestation.styles.store.PortalSelectStyle)
        ctx.theme.registerStyle("portal-text", gr.tech.GRAttestation.styles.store.PortalTextStyle)
        ctx.theme.registerStyle("portal-small-text",
                gr.tech.GRAttestation.styles.store.PortalSmallTextStyle)
        ctx.theme.registerStyle("store-navbar", gr.tech.GRAttestation.styles.store.StoreNavbarStyle)
        ctx.theme.registerStyle("store-navbar-container",
                gr.tech.GRAttestation.styles.store.StoreNavbarContainerStyle)
        ctx.theme.registerStyle("store-navbar-logo",
                gr.tech.GRAttestation.styles.store.StoreNavbarLogoStyle)
        ctx.theme.registerStyle("store-navbar-store-info",
                gr.tech.GRAttestation.styles.store.StoreNavbarStoreInfoStyle)
        ctx.theme.registerStyle("store-navbar-store-name",
                gr.tech.GRAttestation.styles.store.StoreNavbarStoreNameStyle)
        ctx.theme.registerStyle("store-navbar-button",
                gr.tech.GRAttestation.styles.store.StoreNavbarButtonStyle)
        ctx.theme.registerStyle("store-info-banner",
                gr.tech.GRAttestation.styles.store.StoreInfoBannerStyle)
        ctx.theme.registerStyle("store-info-banner-inner",
                gr.tech.GRAttestation.styles.store.StoreInfoBannerInnerStyle)
        ctx.theme.registerStyle("store-info-name",
                gr.tech.GRAttestation.styles.store.StoreInfoNameStyle)
        ctx.theme.registerStyle("store-info-address",
                gr.tech.GRAttestation.styles.store.StoreInfoAddressStyle)
        ctx.theme.registerStyle("store-info-partner",
                gr.tech.GRAttestation.styles.store.StoreInfoPartnerStyle)
        ctx.theme.registerStyle("dashboard-tab-bar",
                gr.tech.GRAttestation.styles.store.DashboardTabBarStyle)
        ctx.theme.registerStyle("dashboard-tab-button-active",
                gr.tech.GRAttestation.styles.store.DashboardTabButtonActiveStyle)
        ctx.theme.registerStyle("dashboard-tab-button-inactive",
                gr.tech.GRAttestation.styles.store.DashboardTabButtonInactiveStyle)
        ctx.theme.registerStyle("dashboard-tab-card",
                gr.tech.GRAttestation.styles.store.DashboardTabCardStyle)
        ctx.theme.registerStyle("dashboard-tab-card-header",
                gr.tech.GRAttestation.styles.store.DashboardTabCardHeaderStyle)
        ctx.theme.registerStyle("dashboard-tab-card-title",
                gr.tech.GRAttestation.styles.store.DashboardTabCardTitleStyle)
        ctx.theme.registerStyle("dashboard-tab-card-subtitle",
                gr.tech.GRAttestation.styles.store.DashboardTabCardSubtitleStyle)
        ctx.theme.registerStyle("dashboard-tab-card-body",
                gr.tech.GRAttestation.styles.store.DashboardTabCardBodyStyle)
        ctx.theme.registerStyle("attestation-alert-container",
                gr.tech.GRAttestation.styles.store.AttestationAlertContainerStyle)
        ctx.theme.registerStyle("attestation-alert-list",
                gr.tech.GRAttestation.styles.store.AttestationAlertListStyle)
        ctx.theme.registerStyle("attestation-alert-checkbox",
                gr.tech.GRAttestation.styles.store.AttestationAlertCheckboxStyle)
        ctx.theme.registerStyle("success-checkmark-circle",
                gr.tech.GRAttestation.styles.store.SuccessCheckmarkCircleStyle)
        ctx.theme.registerStyle("account-management",
                gr.tech.GRAttestation.styles.user.accountManagementStyle)
        ctx.theme.registerStyle("profile-information",
                gr.tech.GRAttestation.styles.user.profileInformationStyle)
        ctx.theme.registerStyle("profile-header-title",
                gr.tech.GRAttestation.styles.user.profileHeaderTitleStyle)
        ctx.theme.registerStyle("profile-input-label",
                gr.tech.GRAttestation.styles.user.profileInputLabelStyle)
        ctx.theme.registerStyle("profile-input",
                gr.tech.GRAttestation.styles.user.profileInputStyle)
        ctx.theme.registerStyle("profile-row", gr.tech.GRAttestation.styles.user.profileRowStyle)
        ctx.theme.registerStyle("bear-input-styling", gr.tech.GRAttestation.util.BearInputStyling)
        ctx.theme.registerKeyframes("modal-overlay-fade-in",
                gr.tech.GRAttestation.components.modals.ModalOverlayFadeInAnimation)
        ctx.theme.registerKeyframes("modal-content-slide-up",
                gr.tech.GRAttestation.components.modals.ModalContentSlideUpAnimation)
        ctx.theme.registerKeyframes("gr-loading-spinner",
                gr.tech.GRAttestation.components.widgets.grLoadingSpinnerAnimation)
        ctx.theme.registerKeyframes("pdf-loading-spinner",
                gr.tech.GRAttestation.styles.PDFLoadingSpinnerAnimation)
        gr.tech.GRAttestation.styles.initSiteStyles(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "root") {
        gr.tech.GRAttestation.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
